import React from "react";
import "./BasesSorteo2026.css"

const BasesSorteo2026 = (props) => {
    const BASE_URL = process.env.REACT_APP_URL_CONFIG;

    return (
        <div className="bs26-page">
            <div className="bs26-content">
                <header className="bs26-header">
                    <img
                        className="bs26-logo"
                        src={`${BASE_URL}/assets/imgs/unicef/teleton2026/logo-teleton.png`}
                        alt="Teletón UNICEF 2026"
                    />
                    <h1>BASES Y CONDICIONES DEL SORTEO</h1>
                    <h2>Teletón UNICEF 2026</h2>
                    <h3>Domingo 20 de septiembre de 2026 | 19:00 a 23:00</h3>
                </header>

                <section className="bs26-intro">
                    <p>El Fondo de las Naciones Unidas para la Infancia (UNICEF) agradece a <strong>IMCRUZ, BISA
                        Seguros, Estropical, PedidosYa, Marathon, Nexocorp, y los restaurantes Caudal y El
                        Arriero</strong>, empresas comprometidas con la niñez que contribuyen con los premios destacados
                        a continuación, en apoyo a la Teletón, como un reconocimiento a los donantes individuales que,
                        con sus aportes mensuales, contribuyen a la realización de la misión de UNICEF. A continuación,
                        se presentan las bases que rigen el sorteo y la entrega de estos premios.</p>
                </section>

                <div className="bs26-callout">
                    <p><strong>Aceptación de las bases.</strong> La participación en el sorteo implica el conocimiento y
                        la aceptación íntegra de estas bases y condiciones.</p>
                </div>

                <section className="bs26-section">
                    <h2>1. Organización, finalidad y ámbito</h2>
                    <p>El sorteo es organizado por UNICEF Bolivia en el marco de la séptima versión de la Teletón UNICEF
                        2026, una iniciativa solidaria destinada a movilizar recursos en favor de la niñez en Bolivia. La
                        actividad se desarrollará en el Estado Plurinacional de Bolivia.</p>
                </section>

                <section className="bs26-section">
                    <h2>2. Premios</h2>
                    <ol>
                        <li>Un (1) vehículo Suzuki Alto, modelo 2027, cero kilómetros.</li>
                        <li>Una (1) póliza de seguro automotor por un año, sujeta a evaluación y a las condiciones de
                            BISA Seguros.
                        </li>
                        <li>Un (1) paquete vacacional al caribe para 2 personas:
                            <ul>
                                <li>Viaje todo incluido a la Riviera Maya - México</li>
                                <li>Boletos ida y vuelta</li>
                                <li>5 noches 6 días en el Hotel Catalonia</li>
                                <li>Traslado aeropuerto/ hotel / aeropuerto</li>
                            </ul>
                        </li>
                        <li>Diez (10) vales de consumo de PedidosYa por Bs 1.000 cada uno.</li>
                        <li>Una (1) polera del FC Barcelona, temporada 2021, autografiada por Lionel Messi y acompañada
                            de su certificado de autenticidad.
                        </li>
                        <li>Una (1) polera autografiada de la selección boliviana de fútbol.</li>
                        <li>Una (1) polera autografiada del Club Bolívar.</li>
                        <li>Una (1) polera autografiada del Club The Strongest.</li>
                        <li>Una (1) polera autografiada del Club Oriente Petrolero.</li>
                        <li>Una (1) polera autografiada del Club Blooming.</li>
                        <li>Cinco (5) hervidores eléctricos de 1,7 litros, marca Masterpro.</li>
                        <li>Dos (2) tostadoras de dos rebanadas, marca Masterpro.</li>
                        <li>Dos (2) vales de consumo por Bs 500 cada uno del restaurante Caudilla, en Santa Cruz.</li>
                        <li>Dos (2) vales de consumo por Bs 500 cada uno del restaurante El Arriero, en Santa Cruz.</li>
                    </ol>

                    <p className="bs26-note">Los premios no son canjeables por dinero ni podrán sustituirse a solicitud
                        de la persona ganadora. Su uso estará sujeto a la disponibilidad, vigencia, cobertura,
                        restricciones y demás condiciones establecidas por cada empresa auspiciadora.</p>
                </section>

                <section className="bs26-section">
                    <h2>3. Personas habilitadas para participar</h2>
                    <p>Podrán participar únicamente personas naturales mayores de 18 años que cuenten con un documento
                        de identidad vigente y se encuentren en alguna de las siguientes categorías:</p>
                    <ul>
                        <li><strong>Donantes mensuales recurrentes activos antiguos</strong>, registrados como activos y
                            con sus donaciones al día al 20 de septiembre de 2026.
                        </li>
                        <li><strong>Donantes mensuales recurrentes nuevos</strong>, afiliados entre el 10 de agosto y
                            las 21:30 del 20 de septiembre de 2026, cuya afiliación figure activa en los registros de
                            UNICEF.
                        </li>
                        <li><strong>Donantes de aporte único (one-off)</strong>, que hayan realizado una donación
                            mediante los códigos QR habilitados por UNICEF entre el 3 de julio y las 22:00 del 20 de
                            septiembre de 2026.
                        </li>
                        <li><strong>Participantes de juegos en el escenario</strong>, seleccionados entre el público
                            durante la Teletón, entre las 19:00 y las 23:00 del 20 de septiembre de 2026, conforme a la
                            dinámica anunciada para cada juego.
                        </li>
                    </ul>
                </section>

                <section className="bs26-section">
                    <h2>4. Exclusiones y restricciones</h2>
                    <ul>
                        <li>No podrán participar las personas menores de 18 años.</li>
                        <li>No podrán participar el personal de UNICEF Bolivia y RED UNO, ni su cónyuge o conviviente ni
                            sus familiares hasta el primer grado de consanguinidad o afinidad.
                        </li>
                        <li>Una misma persona podrá contar con varias oportunidades de participación; sin embargo, solo
                            podrá ganar un premio en el conjunto de sorteos de la Teletón UNICEF 2026. Si una persona
                            que ya hubiera obtenido un premio resultara seleccionada nuevamente, se informará que ya fue
                            ganadora y se realizará un nuevo sorteo hasta seleccionar a una persona habilitada.
                        </li>
                        <li>Si una persona seleccionada no cumple los requisitos, está comprendida en alguna exclusión o
                            proporcionó información falsa, incompleta o inconsistente, será descalificada y se procederá
                            conforme al mecanismo de reemplazo previsto en estas bases.
                        </li>
                    </ul>
                </section>

                <section className="bs26-section">
                    <h2>5. Oportunidades de participación</h2>
                    <p>La antigüedad de los donantes recurrentes se calculará al 20 de septiembre de 2026. Las
                        oportunidades son acumulables cuando corresponda y se asignarán de la siguiente manera:</p>

                    <div className="bs26-table-responsive">
                        <table className="bs26-table">
                            <thead>
                                <tr>
                                    <th>Condición</th>
                                    <th>Oportunidades</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td>Donante activo antiguo o nuevo con antigüedad menor a 1 año</td>
                                    <td>5</td>
                                </tr>
                                <tr>
                                    <td>Donante activo con antigüedad de 1 a 3 años</td>
                                    <td>10</td>
                                </tr>
                                <tr>
                                    <td>Donante activo con antigüedad 3 a 5 años</td>
                                    <td>15</td>
                                </tr>
                                <tr>
                                    <td>Donante activo con antigüedad mayor a 5 años</td>
                                    <td>20</td>
                                </tr>
                                <tr>
                                    <td>Incremento de la donación mensual vigente por Bs 20 o más, gestionado mediante
                                        la línea <a href="tel:800109333">800-10-9333</a></td>
                                    <td>+1</td>
                                </tr>
                                <tr>
                                    <td>Aporte extraordinario adicional a la donación mensual, realizado entre el 1 y el
                                        20 de septiembre de 2026
                                    </td>
                                    <td>+1</td>
                                </tr>
                                <tr>
                                    <td>Aporte único (one-off) mediante QR habilitado por UNICEF</td>
                                    <td>1 por cada Bs 50</td>
                                </tr>
                                <tr>
                                    <td>Participante de un juego en el escenario</td>
                                    <td>Según la dinámica y el premio anunciados para el juego</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>

                    <p className="bs26-note">Los aportes inferiores a Bs 50 no generan una oportunidad por aporte único.
                        En los aportes superiores, solo se contabilizarán múltiplos completos de Bs 50; las fracciones no
                        se acumularán entre transacciones distintas. Solo se considerarán operaciones efectivamente
                        recibidas e identificadas en los registros de UNICEF dentro de los plazos establecidos.</p>
                </section>

                <section className="bs26-section">
                    <h2>6. Fecha, lugar y mecanismo del sorteo</h2>
                    <ul>
                        <li>Los sorteos se realizarán el domingo 20 de septiembre de 2026, entre las 19:00 y las 23:00,
                            durante la transmisión en vivo de la Teletón UNICEF, desde el escenario principal de
                            EXPOCRUZ, en Santa Cruz de la Sierra.
                        </li>
                        <li>La transmisión se realizará por la señal nacional de RED UNO y, simultáneamente, por los
                            canales digitales habilitados por RED UNO y UNICEF.
                        </li>
                        <li>El sorteo se efectuará mediante una tómbola digital que seleccionará aleatoriamente las
                            oportunidades válidas registradas en la base de participantes.
                        </li>
                        <li>El proceso contará con la presencia de una notaria o un notario de fe pública, quien dará fe
                            del procedimiento y sus resultados.
                        </li>
                        <li>Antes de cada asignación, UNICEF verificará la identidad y elegibilidad de la persona
                            seleccionada. Si no cumple las bases, se realizará una nueva selección para ese premio.
                        </li>
                        <li>El orden de asignación de los premios será definido por UNICEF y anunciado durante la
                            transmisión.
                        </li>
                    </ul>
                </section>

                <section className="bs26-section">
                    <h2>7. Anuncio, contacto y acreditación de las personas ganadoras</h2>
                    <p>Durante la transmisión se anunciará el nombre de cada persona ganadora y, su respectivo documento
                        de identidad. La lista de ganadores se difundirá en las redes sociales oficiales de UNICEF.</p>
                    <p>UNICEF se comunicará con las personas ganadoras mediante los datos registrados. Cada ganador
                        deberá responder, acreditar su identidad y aceptar el premio dentro de los diez (10) días
                        hábiles siguientes a la primera notificación. Será responsabilidad de cada participante mantener
                        actualizados sus datos de contacto.</p>
                    <p>Si una persona ganadora no puede ser contactada, no responde dentro del plazo, rechaza el premio,
                        no acredita su identidad o incumple estas bases, perderá el derecho al premio. UNICEF realizará
                        una nueva selección, con intervención notarial, entre las participaciones válidas
                        correspondientes.</p>
                </section>

                <section className="bs26-section">
                    <h2>8. Entrega y condiciones de los premios</h2>
                    <ul>
                        <li><strong>Vehículo.</strong> La entrega se coordinará en una sucursal de IMCRUZ ubicada en
                            cualquiera de las ciudades capitales de Bolivia (donde tenga presencia IMCRUZ). La persona
                            ganadora deberá trasladarse por sus propios medios hasta la sucursal acordada y asumir los
                            gastos de recojo o traslado del vehículo desde ese lugar. La documentación, los tributos, los
                            gastos de inscripción y cualquier otro costo asociado se regirán por las condiciones que
                            IMCRUZ comuniquen al ganador.
                        </li>
                        <li><strong>Seguro automotor.</strong> La persona ganadora deberá presentarse en una agencia de
                            BISA Seguros en las ciudades capitales de Bolivia y completar la documentación requerida
                            dentro del plazo comunicado. La emisión de la póliza estará sujeta a las condiciones de
                            cobertura, elegibilidad, inspección y suscripción de la aseguradora.
                        </li>
                        <li><strong>Paquete vacacional.</strong> La persona ganadora deberá presentarse en una agencia
                            de ESTROPICAL en eje troncal del país. La reserva y el uso estarán sujetos a la vigencia,
                            disponibilidad, ciudad de salida, fechas habilitadas, documentación de viaje, políticas de
                            cambios o cancelaciones y demás condiciones del proveedor. Los gastos o servicios no
                            expresamente incluidos correrán por cuenta de la persona ganadora.
                        </li>
                        <li><strong>Vales y demás premios.</strong> La persona ganadora deberá presentarse en las
                            oficinas de UNICEF en Santa Cruz o La Paz, o en su defecto coordinar el envío de los
                            premios. Los vales estarán sujetos a su vigencia, cobertura geográfica y condiciones de uso.
                            Los gastos de traslado o envío no expresamente asumidos por la empresa aportante serán
                            responsabilidad del ganador.
                        </li>
                    </ul>

                    <p>Los premios deberán ser recogidos personalmente o por un apoderado con poder notariado
                        suficiente, previa presentación del documento de identidad original vigente de la persona
                        ganadora y, cuando corresponda, del apoderado.</p>
                    <p>La persona ganadora del vehículo que participe como donante mensual declara su compromiso
                        solidario de mantener su donación recurrente durante al menos un año, sujeto a la validación
                        institucional indicada al final de este documento.</p>
                </section>

                <section className="bs26-section">
                    <h2>9. Datos personales, imagen y difusión</h2>
                    <p>Los datos personales proporcionados o registrados serán utilizados por UNICEF para administrar el
                        sorteo, verificar el cumplimiento de estas bases, contactar a las personas ganadoras, coordinar
                        la entrega de premios y atender obligaciones de control y transparencia. UNICEF aplicará medidas
                        razonables de seguridad y limitará la difusión pública de los datos de identificación a lo
                        estrictamente necesario.</p>
                    <p>Al aceptar un premio, la persona ganadora autoriza a UNICEF, RED UNO y a la empresa aportante del
                        premio a utilizar su nombre, imagen, voz, fotografías o videos relacionados con la Teletón y la
                        entrega del premio, exclusivamente con fines informativos, institucionales y de rendición de
                        cuentas, sin que ello genere una compensación económica adicional.</p>
                </section>

                <section className="bs26-section">
                    <h2>10. Fuerza mayor, modificaciones y casos no previstos</h2>
                    <p>UNICEF podrá reprogramar, suspender o modificar el sorteo cuando exista una causa de fuerza
                        mayor, caso fortuito, imposibilidad técnica, disposición de autoridad competente u otra
                        circunstancia ajena a su control que impida ejecutarlo en las condiciones previstas. Cualquier
                        cambio material será comunicado oportunamente por los canales oficiales de UNICEF.</p>
                    <p>Las situaciones no previstas serán resueltas por UNICEF con criterios de transparencia, buena fe,
                        equidad y respeto de la normativa aplicable.</p>
                </section>

                <section className="bs26-section">
                    <h2>11. Consultas y publicación de resultados</h2>
                    <p>Para consultas, las personas interesadas podrán comunicarse con la línea gratuita de UNICEF <a
                        href="tel:800109333">800-10-9333</a> en horarios de oficina. Las presentes bases, sus eventuales
                        modificaciones y la información oficial del sorteo se publicarán en los canales oficiales de
                        UNICEF Bolivia, incluido el sitio web <a href="https://www.unicef.org.bo" target="_blank"
                                                                 rel="noreferrer">www.unicef.org.bo</a></p>
                </section>

                <footer className="bs26-footer">
                    <h2>ES TIEMPO DE ACTUAR | #PorUnaInfanciaFeliz</h2>
                </footer>
            </div>
        </div>
    );
}

BasesSorteo2026.propTypes = {};

export default BasesSorteo2026;
